import Modal from "@mui/material/Modal";
import {kModalStyles} from "../../../constants/styles";
import SystemScreenInfoHeader from "../../headers/SystemScreenInfoHeader";
import {kSystemIcons} from "../../../constants/icons";

export default function LevelAExampleExplanationDialog({open, handleClose}) {
    // Used in LevelAMetaData to display modal with
    // example zoomed picture

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.screenInfoDialogStyle}>
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.flare}
                                        title={"Exemple type"} />
                {/** CONTENT */}
                <div className={"w-full flex flex-col justify-start items-start p-[24px]"}>
                     <span className={"font-bold text-[18px] text-white -mt-[6px] whitespace-pre-line"}>
                       {"Es-tu capable d'utiliser la connaissance pour résoudre un exercice\u00A0?"}
                    </span>
                    <span className={"font-normal text-[14px] text-greyLight9 mt-[12px]"}>
                        {"Dans cet exemple type, la connaissance est appliquée à un énoncé précis. Avant de passer à la prochaine étape, essaie de refaire cet exercice et assure toi de bien comprendre chaque étape de l'explication."}
                    </span>
                </div>
            </div>
        </Modal>
    )
}